import React, { useEffect } from 'react';
import { AppLayout, BreadcrumbGroup, Grid } from '@amzn/awsui-components-react';
import { ApplicationState, isFinancialAnalyst, showErrorPage } from 'modules/app/store';
import { ErrorRouter } from 'modules/error/components';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { BulkEditAccountingStrings } from '../components';

export const BulkEditCoa = () => {
    const { t } = useTranslation('bulkEdit');
    const applicationHealth = useSelector((state: ApplicationState) => state.applicationHealth);

    const dispatch = useDispatch();
    const isFA = useSelector(isFinancialAnalyst);

    const breadcrumbItems = [
        { text: t('coaStingsBreadCrumbs.dashboard'), href: '/budget' },
        {
            text: t('coaStingsBreadCrumbs.bulkEditCoa'),
            href: '#'
        }
    ];

    useEffect(() => {
        if (isFA) return;

        dispatch(showErrorPage({ errorCode: 401 }));
    }, []);

    return (
        <AppLayout
            content={
                applicationHealth.showError ? (
                    <ErrorRouter errorStatusCode={applicationHealth.errorCode} />
                ) : (
                    <Grid gridDefinition={[{ colspan: 1 }, { colspan: 10 }, { colspan: 1 }]}>
                        <div></div>
                        <div>
                            <BulkEditAccountingStrings />
                        </div>
                        <div></div>
                    </Grid>
                )
            }
            breadcrumbs={<BreadcrumbGroup ariaLabel="Breadcrumbs" items={breadcrumbItems} />}
            toolsHide={true}
            navigationHide={true}
        />
    );
};
